export default __webpack_public_path__ + "static/media/pictoOffre.3c7b02c5.png";